import { DashboardConfig } from '@modules/auth/interfaces';
import { createReducer, on } from '@ngrx/store';
import * as fromAuth from '../actions/auth.actions';

export const authFeatureKey = 'auth';

export interface AuthState {
    user: string | null;
    clientConfig: DashboardConfig | null;
    userScope: any;
    access_token: string | null;
    loading: boolean;
    loaded: boolean;
    loginFailed: boolean;
}
export const initialState: AuthState = {
    user: null,
    clientConfig: null,
    userScope: null,
    access_token: null,
    loading: false,
    loaded: false,
    loginFailed: false
};

export const reducer = createReducer(
    initialState,
    on(fromAuth.LogInWithLocal, (state) => ({
        ...state,
        loading: true
    })),
    on(fromAuth.LogInWithLocalSuccess, (state, { payload }) => ({
        ...state,
        clientConfig: payload.clientConfig,
        user: payload.email,
        userScope: { userType: payload.userType, name: payload.name, cities: payload.scope },
        access_token: payload.access_token,
        refresh_token: payload.refresh_token,
        loading: false,
        loaded: true,
        loginFailed: false
    })),
    on(fromAuth.LogInWithLocalFail, (state) => ({
        ...state,
        loading: false,
        loaded: false,
        loginFailed: true
    })),
    on(fromAuth.LogIn, (state) => ({
        ...state,
        loading: true
    })),
    on(fromAuth.RefreshTokens, (state, { payload }) => ({
        ...state,
        access_token: payload.accessToken,
        refresh_token: payload.refreshToken
    })),
    on(fromAuth.LogInSuccess, (state, { payload }) => ({
        ...state,
        user: payload.email,
        userScope: {
            userType: payload.miaas_userType,
            name: payload.name,
            cities: payload.miaas_cities
        },
        access_token: null,
        loading: false,
        loaded: true,
        loginFailed: false
    })),
    on(fromAuth.LogInFail, (state) => ({
        ...state,
        loading: false,
        loaded: false,
        loginFailed: true
    })),
    on(fromAuth.LogInWithSession, (state) => ({
        ...state,
        loading: true
    })),
    on(fromAuth.LogInWithSessionSuccess, (state, { payload }) => ({
        ...state,
        user: payload.email,
        userScope: {
            userType: payload.miaas_userType,
            name: payload.name,
            cities: payload.miaas_cities
        },
        access_token: null,
        loading: false,
        loaded: true,
        loginFailed: false
    })),
    on(fromAuth.LogInWithSupabase, (state) => ({
        ...state,
        loading: true
    })),
    on(fromAuth.LogInWithSupabaseSuccess, (state, { payload }) => ({
        ...state,
        user: payload.email,
        userScope: { userType: payload.user_type, name: payload.name, cities: payload.user_scope },
        access_token: payload.access_token,
        loading: false,
        loaded: true,
        loginFailed: false
    })),
    on(fromAuth.ResetAuthState, (_) => ({
        ...initialState
    })),
    on(fromAuth.LogOut, (_) => ({
        clientConfig: null,
        user: null,
        userScope: null,
        access_token: null,
        loading: false,
        loaded: false,
        loginFailed: false
    }))
);

export const getLoginFailed = (state: AuthState) => state.loginFailed;
export const getClientConfig = (state: AuthState) => state.clientConfig;
export const getUser = (state: AuthState) => state.user;
export const getUserScope = (state: AuthState) => state.userScope;
export const getAuthenticationLoading = (state: AuthState) => state.loading;
export const getAuthenticationLoaded = (state: AuthState) => state.loaded;
export const getAccessToken = (state: AuthState) => state.access_token;
